const INTEGRATED_PARTNER_ROLE = "Integrated Partner" as const;

const isIntegratedPartner = (splatRole?: string) =>
  splatRole === INTEGRATED_PARTNER_ROLE;

export { INTEGRATED_PARTNER_ROLE, isIntegratedPartner };
